const base = import.meta.env.BASE_URL || "/";

export function assetPath(path: string) {
  return `${base}${path.replace(/^\//, "")}`;
}

export function routePath(path: string) {
  if (base === "/") return path;
  const cleanBase = base.replace(/\/$/, "");
  return `${cleanBase}${path === "/" ? "" : path}`;
}
